import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface CierresDesplazamientosPayload {
  desplazamiento_id: number;
  fecha_cierre: string;
  hora_llegada_real?: string | null;
  kilometraje_final?: number | null;
  estado_cierre?: number;
  cumplimiento?: number | null;
  observaciones?: string | null;
}

/**
 * 🔹 Entidad
 */
export interface CierresDesplazamientos {
  id?: number;
  desplazamiento_id: number;
  fecha_cierre: string;
  hora_llegada_real?: string | null;
  kilometraje_final?: number | null;
  estado_cierre: number;
  cumplimiento?: number | null;
  observaciones?: string | null;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface CierresDesplazamientosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class CierresDesplazamientosService {
  private readonly apiUrl = `${environment.apiUrl}/api/cierres_desplazamientos`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los cierres
   */
  getAll(): Observable<CierresDesplazamientos[]> {
    return this.http.get<CierresDesplazamientos[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener cierre por ID
   */
  getById(id: number): Observable<CierresDesplazamientos> {
    return this.http.get<CierresDesplazamientos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear cierre
   */
  create(
    payload: CierresDesplazamientosPayload
  ): Observable<CierresDesplazamientosResponse> {
    return this.http.post<CierresDesplazamientosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar cierre
   */
  update(
    id: number,
    payload: Partial<CierresDesplazamientosPayload>
  ): Observable<CierresDesplazamientosResponse> {
    return this.http.put<CierresDesplazamientosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar cierre
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar cierre
   */
  inactivar(id: number): Observable<CierresDesplazamientosResponse> {
    return this.http.put<CierresDesplazamientosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar cierre
   */
  activar(id: number): Observable<CierresDesplazamientosResponse> {
    return this.http.put<CierresDesplazamientosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}